import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
import type { StorageLocal } from "@/utils/storageLocal";
import { storageLocal } from "@/utils/storageLocal";

/**
 * webストレージを操作するカスタムフック
 */
export const useStorage = (key, t0, t1) => {
  const $ = _c(11);
  const initial = t0 === undefined ? "" : t0;
  const storageType = t1 === undefined ? "session" : t1;
  const [storage, setStorage] = useState();
  const [value, setValue] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  let t2;
  let t3;
  if ($[0] !== initial || $[1] !== key || $[2] !== storageType) {
    t2 = () => {
      const storageInstance = storageLocal(key, initial, storageType);
      setStorage(storageInstance);
      setValue(storageInstance.read());
      setIsInitialized(true);
    };
    t3 = [key, initial, storageType];
    $[0] = initial;
    $[1] = key;
    $[2] = storageType;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== storage) {
    t4 = newValue => {
      if (storage) {
        storage.write(newValue);
        setValue(newValue);
      }
    };
    $[5] = storage;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const write = t4;
  let t5;
  if ($[7] !== isInitialized || $[8] !== value || $[9] !== write) {
    t5 = {
      value,
      write,
      isInitialized
    };
    $[7] = isInitialized;
    $[8] = value;
    $[9] = write;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};